import { Pipe, PipeTransform } from '@angular/core';

import {
  Partners,
  QuoteType,
  QuoteWorkflowStatus,
} from '@lockton-apps/shared/interfaces';

import { WorkflowStatusMeta } from './core/interface';
import { getPaymentWorkflowMeta } from './core/payment-workflow-meta';

@Pipe({
  name: 'paymentWorkflowMeta',
  standalone: true,
})
export class PaymentWorkflowMetaPipe implements PipeTransform {
  transform(
    status: QuoteWorkflowStatus,
    quoteType: QuoteType,
    partner?: Partners
  ): WorkflowStatusMeta {
    return getPaymentWorkflowMeta(status, quoteType, partner);
  }
}
